import { observable, action, runInAction } from "mobx";
import { getLabel } from '@weapp/utils';
import { MDialog } from '@weapp/ui';

import { checkMobileType, checkSkipType } from "./type";
import * as SignAPI from "../../../api/pc/signup";
import { getTokenStorage } from "../../../utils";
import { qryDumpAccountVaild } from "../../../api/pc/signup";

const { toast } = MDialog;

export class mSignVerifyStore {
  @observable isShowSkipVerifyBtn = "E"

  // 发送验证码
  sendMsg = () => {
    SignAPI.sendMobileCode({ userIdToken: getTokenStorage() }).then((result) => {
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        toast({
          content: getLabel(msg.i18nId, msg.msg)
        })
      }
    });
  }
  // 校验验证码
  checkVerify = (params: checkMobileType, callback?: () => void) => {
    SignAPI.checkMobileCode(params).then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        toast({
          content: getLabel(msg.i18nId, msg.msg)
        })
      } else {
        callback && callback();
      }
    });
  }

  /**
   * 判断是否显示跳过验证按钮
   */
  @action
  qryDumpAccountVaild = async () => {
    const res = await qryDumpAccountVaild()
    console.log("res", res);
    runInAction(() => {
      this.isShowSkipVerifyBtn = res?.data?.configValue || "E"
    })

  }

  /**
   * 跳过验证
   * @param callback 
   */
  @action
  skipVerify = (params: checkSkipType, callback?: () => void) => {
    SignAPI.skipValidate(params).then((result) => {
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        toast({
          content: getLabel(msg.i18nId, msg.msg)
        });
      } else {
        //从邀请来
        if (params.joinKey && result.data?.redirectUrl) {
          window.location.href = result.data?.redirectUrl;
          return;
        }
        callback && callback();
      }
    });
  }
  //重发邮件
  @action
  sendEmail = (onSuccess?: Function) => {
    SignAPI.sendEmail().then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        toast({
          content: getLabel(msg.i18nId, msg.msg)
        })
      } else {
        onSuccess?.();
      }
    });
  }

  // initEmployee = (obj: any) => {
  //   SignupAPI.initEmployee(obj).then((result: any) => {
  //     if (result.message) {
  //       message({
  //         type: "error",
  //         content: result.message,
  //       });
  //     }
  //   }).catch((error: any) => {
  //     console.log(error);
  //   });
  // };

}

const instance = new mSignVerifyStore();

export default instance;
